import { render } from "./EquipeSelector.vue?vue&type=template&id=333c7f73&scoped=true"
import script from "./EquipeSelector.vue?vue&type=script&lang=js"
export * from "./EquipeSelector.vue?vue&type=script&lang=js"

import "./EquipeSelector.vue?vue&type=style&index=0&id=333c7f73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333c7f73"]])

export default __exports__